import { forwardRef } from "react";
import { cn } from "@/utils/cn";
import ApperIcon from "@/components/ApperIcon";

const Button = forwardRef(({
  variant = "primary",
  size = "default",
  icon,
  children,
  className,
  disabled,
  loading,
  ...props
}, ref) => {
  const baseClasses = "inline-flex items-center justify-center gap-2 font-medium transition-all duration-normal focus:outline-none focus:ring-2 focus:ring-primary/50 disabled:opacity-50 disabled:cursor-not-allowed";
  
  const variantClasses = {
    primary: "bg-primary hover:bg-primary-600 active:bg-primary-700 text-white shadow-lg hover:shadow-xl",
    secondary: "bg-surface hover:bg-surface/80 border border-primary/20 hover:border-primary/30 text-white",
    ghost: "hover:bg-primary/10 text-gray-300 hover:text-white",
    danger: "bg-red-600 hover:bg-red-700 active:bg-red-800 text-white shadow-lg",
    outline: "border border-primary hover:bg-primary hover:text-white text-primary"
  };
  
  const sizeClasses = {
    sm: "px-3 py-1.5 text-body-sm rounded-button",
    default: "px-4 py-2.5 text-body-base rounded-button",
    lg: "px-6 py-3 text-body-base rounded-button"
  };

  return (
    <button
      ref={ref}
      className={cn(
        baseClasses,
        variantClasses[variant],
        sizeClasses[size],
        loading && "opacity-75 cursor-wait",
        className
      )}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <ApperIcon name="Loader2" className="w-4 h-4 animate-spin" />
      ) : icon ? (
        <ApperIcon name={icon} className="w-4 h-4" />
      ) : null}
      {children}
    </button>
  );
});

Button.displayName = "Button";

export default Button;